module.exports = __webpack_public_path__ + "static/media/garlandMain.a85e0a01.png";